import React, { Suspense } from 'react';

import { ChunkLoadErrorBoundary, ErrorBoundary } from '@trello/error-reporting';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { FreeTrialBannerProps } from './FreeTrialBanner';

export function LazyFreeTrialBanner(props: FreeTrialBannerProps) {
  const FreeTrialBanner = useLazyComponent(
    () =>
      import(/* webpackChunkName: "free-trial-banner" */ './FreeTrialBanner'),
    {
      preload: false,
      namedImport: 'FreeTrialBanner',
    },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-mocha',
          feature: 'Free Trial',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <FreeTrialBanner {...props} />
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
}
